// extracted by mini-css-extract-plugin
module.exports = {"mainContainerPeople":"styles_mainContainerPeople__czfv5"};